import React from "react";
import { Carousel as Car } from "react-bootstrap";
import { Link } from "react-router-dom";
const img1 = require("../assets/IMG_0388.JPG");
const img2 = require("../assets/IMG_0426.JPG");
const img3 = require("../assets/IMG_6910.JPG");
const img4 = require("../assets/IMG_7166.JPG");

function Carousel() {
    const buttonStyle = {
        backgroundColor: "#073553",
        color: "white"
    }
    return (
        <Car>
            <Car.Item>
                <img className="d-block w-100" src={img1} alt="First slide" style={{ height: "28rem" }}/>
                <Car.Caption className="text-start">
                    <h1 style={{ textShadow: "3px 3px #000000" }}>Meetings</h1>
                    <h6 style={{ textShadow: "2px 2px #000000" }}>Stay up to date with the latest meetings, events, and other opportunities to provide input.</h6>
                    <Link to="/meetings"><button className="btn btn-lg" style={buttonStyle}>View Meetings</button></Link>
                </Car.Caption>
            </Car.Item>
            <Car.Item>
                <img className="d-block w-100" src={img2} alt="Second slide" style={{ height: "28rem" }}/>
                <Car.Caption className="text-start">
                    <h1 style={{ textShadow: "3px 3px #000000" }}>Survey</h1>
                    <h6 style={{ textShadow: "2px 2px #000000" }}>The online survey is now closed. Thanks to everyone who participated!</h6>
                </Car.Caption>
            </Car.Item>
            <Car.Item>
                <img  className="d-block w-100"  src={img3} alt="Third slide" style={{ height: "28rem" }}/>
                <Car.Caption className="text-end">
                    <h1 style={{ textShadow: "3px 3px #000000" }}>Documents</h1>
                    <h6 style={{ textShadow: "2px 2px #000000" }}>View adopted plans</h6>
                    <Link to="/documents"><button className="btn btn-lg" style={buttonStyle}>View Documents</button></Link>
                </Car.Caption>
            </Car.Item>
            <Car.Item>
                <img  className="d-block w-100"  src={img4} alt="Fourth slide" style={{ height: "28rem" }}/>
                <Car.Caption className="text-end">
                    <h1 style={{ textShadow: "3px 3px #000000" }}>Have A Comment?</h1>
                    <h6 style={{ textShadow: "2px 2px #000000" }}>Your feedback is important to us.</h6>
                    <Link to="/comment"><button className="btn btn-lg" style={buttonStyle}>Send Us A Comment</button></Link>
                </Car.Caption>
            </Car.Item>
        </Car>
    );
}

export default Carousel;